import logo from '../logo.svg';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Hero from '../components/hero';
import MyCarousel from '../components/mycarousel';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../App.css';
import Contact from '../components/contactForm';
import MediaAlbum from '../components/media';
import ActividadProfesional from "../components/consultoras";

function Home() {
  return (
    <>
      <Hero/>
      <MyCarousel/>
      <MediaAlbum/>
      <Contact/>
      <ActividadProfesional/>
    </>
  );
}

export default Home;